import {INavigableValidatableModel} from "~/interfaces/navigableValidationInterfaces";
import ValidationError from "../validationError";
import {ValidationResultValueInterface} from "~/interfaces/validationResultInterface";
import {ValidationErrorMessage} from "~/enums/validationErrorMessage";
import {ErrorType} from "~/enums/ErrorType" ;
import EmbeddedCollectionValidator from "~/models/navigableValidators/embeddedCollectionValidator";

export default class EmbeddedFieldValidator<T> extends EmbeddedCollectionValidator<T> {
  defaultMessage = ValidationErrorMessage.MustBePresent;
  defaultType = ErrorType.mustBePresent;
  allChildren: INavigableValidatableModel<T>[] = [];

  get results(): ValidationResultValueInterface[] {
    const errors = this.errors.slice();
    return errors.length ? errors.map(error => {
      return {
        [error.field]: {
          errors: [error],
          displayName: error.displayName,
          errorNavOpts: error.errorNavOpts
        }
      };
    }) : [];
  }

  protected getAllChildren(model) {
    if (model[this.field] instanceof Object) {
      return [model[this.field]];
    } else if (model[this.field] instanceof Array) {
      return model[this.field].map((nestedObj) => {
        return nestedObj;
      });
    }
  }

  buildValidationError(model: INavigableValidatableModel<T>, value?) {
    return new ValidationError({
      message: this.options.message || this.defaultMessage,
      displayName: '',
      errorNavOpts: model.validation.errorNavOpts(this, this.field, value),
      section: this.section
    });
  }
}